import { Controller } from "@hotwired/stimulus";
import EasyMDE from "easymde";

export default class extends Controller {
  static values = {
    pageId: String,
  };

  toggle() {
    const previewId = `preview-container-${this.pageIdValue}`;
    let container = document.getElementById(previewId);

    if (container) {
      // Toggle existing container
      container.classList.toggle("hidden");
    } else {
      // Fetch latest content from server
      this.fetchAndCreatePreview();
    }
  }

  async fetchAndCreatePreview() {
    try {
      // Fetch the latest page data including image URLs
      const response = await fetch(`/extracted_pages/${this.pageIdValue}.json`);
      const data = await response.json();

      // Replace <!-- image --> placeholders with inline images
      let imageIndex = 0;
      const content = data.md_content.replace(/<!--\s*image\s*-->/gi, () => {
        const url = data.image_urls && data.image_urls[imageIndex];
        imageIndex++;
        return url
          ? `![image ${imageIndex}](${url})`
          : `<!-- image ${imageIndex} (not available) -->`;
      });

      this.createPreview(content);
    } catch (error) {
      console.error("Failed to fetch page content:", error);
    }
  }

  createPreview(content) {
    const pageRow = this.element.closest("tr");

    // Create container row
    const container = document.createElement("tr");
    container.id = `preview-container-${this.pageIdValue}`;
    container.innerHTML = `
      <td colspan="4" class="px-6 py-4 bg-gray-50">
        <div id="easymde-wrapper-${this.pageIdValue}" class="bg-white rounded border border-gray-200"></div>
      </td>
    `;

    pageRow.insertAdjacentElement("afterend", container);

    // Create textarea and initialize EasyMDE
    const textarea = document.createElement("textarea");
    textarea.value = content;
    const wrapperDiv = document.getElementById(
      `easymde-wrapper-${this.pageIdValue}`,
    );
    wrapperDiv.appendChild(textarea);

    const editor = new EasyMDE({
      element: textarea,
      toolbar: false,
      minHeight: "400px",
      autoDownloadFontAwesome: false,
      spellChecker: false,
      readOnly: true,
    });

    // Auto-switch to preview mode after initialization
    setTimeout(() => {
      editor.togglePreview();
      // Make image links open in a new tab
      const wrapper = editor.codemirror.getWrapperElement().parentNode;
      const previewEl = wrapper.querySelector(".editor-preview");
      if (previewEl) {
        previewEl.querySelectorAll('a[href*="/image/"]').forEach((a) => {
          a.setAttribute("target", "_blank");
        });
      }
    }, 100);
  }
}
